import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardActionArea,
  CardContent,
  Typography
} from "@mui/material";
import ArrowForwardIosSharp from "@mui/icons-material/ArrowForwardIosSharp";
import { RootState } from "../../../../store";
import styles from "./appointments.module.scss";
import { ResourceCentre } from "../../../../interfaces/ResourceCentreInterface";
import { setSelectedBranch } from "../../../../slices/clientPortalUserInfoSlice";

const BranchSelect = ({
  onSelectStep
}: {
  onSelectStep: (s: number) => void;
}): React.JSX.Element => {
  const dispatch = useDispatch();
  const branches = useSelector((state: RootState) => state.clientPortalUserInfo.branches);
  const handleSelectBranch = (branch: ResourceCentre) => {
    dispatch(setSelectedBranch(branch));
  };
  const rc = useSelector(
    (state: RootState) => state.clientPortalUserInfo?.user?.user?.resourceCentre
  );
  const [showOthers, setShowOthers] = React.useState<boolean>(true);
  return (
    <div className={styles.branchContainer}>
      <Card className={styles.card}>
        <CardActionArea
          onClick={() => {
            onSelectStep(1);
            handleSelectBranch(rc);
          }}
        >
          <CardContent>
            <Typography variant="h6">{rc?.name}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      <Accordion
        sx={{ marginTop: "15px" }}
        expanded={showOthers}
        onChange={() => setShowOthers((prev) => !prev)}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          expandIcon={
            showOthers ? (
              <ArrowForwardIosSharp sx={{ rotate: "-90deg" }} />
            ) : (
              <ArrowForwardIosSharp />
            )
          }
        >
          <Typography variant="h6" component="span">
            Others
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className={styles.others}>
            {branches.map((branch: ResourceCentre) => (
              <Card key={branch.id} className={styles.card}>
                <CardActionArea
                  onClick={() => {
                    onSelectStep(1);
                    handleSelectBranch(branch);
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">{branch?.name}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default BranchSelect;
